export const TransferStation = {
  // routeInfo 挂在GlobalEnv上，作为中间者存在
  routeInfo: {
    // 线路信息
    // [goodsId]:
    //   allowCreateOrderFlag: false, // 标志位
    // startRoute: {}, // 起点
    // endRoute: {}, // 终点
    // },
  },
  /** 城市map */
  cityMap: {
    // [lang]: {}
  },
}
// 此文件只是用来中转各种业务数据，不作核心实质处理
export const getStationRouteInfo = goodsId => {
  return TransferStation.routeInfo[Number(goodsId)]
}
export const setStationRouteInfo = (goodsId, routeInfo, opts) => {
  if (!goodsId) {
    return
  }
  if (!getStationRouteInfo(goodsId) || opts?.reset) {
    TransferStation.routeInfo[Number(goodsId)] = {
      goodsId,
      startRoute: {},
      endRoute: {},
      watched: false,
      productType: null,
      routeType: null,
      allowCreateOrderFlag: false,
    }
  }
  if (opts.reset) {
    return getStationRouteInfo(goodsId)
  }
  if (opts?.extend) {
    Object.assign(TransferStation.routeInfo[Number(goodsId)], routeInfo)
  } else {
    TransferStation.routeInfo[Number(goodsId)] = routeInfo
  }
  return getStationRouteInfo(goodsId)
}

export const setStationCityMap = (lang, cityMap) => {
  TransferStation.cityMap[lang] = cityMap
}
export const getStationCityMap = lang => {
  return TransferStation.cityMap[lang]
}
